import { apiSlice } from "../app/api/apiSlice";

export const UserVehicleApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getPaginatedUserVehicles: builder.query({
            query: ({user_id, paginate, page}) => (page == "")? `/user/user-vehicles/${user_id}/${paginate}` : `user/user-vehicles/${user_id}/${paginate}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['UserVehicles']
        }),
        getUserVehiclePageChange: builder.mutation({
            query: ({user_id, paginate, page}) => `user/user-vehicles/${user_id}/${paginate}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['UserVehicles']
        }),
        getUserVehiclesForRoutes: builder.query({
            query: ({user_id}) => `/user/vehicles/${user_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['UserVehicles']
        }),
        createUserVehicle: builder.mutation({
            query: (input) => ({
                url: `/user/create-vehicle`,
                method: 'POST',
                body: { ...input }
            }),
            invalidatesTags: ['UserVehicles']
        }),
        editUserVehicle: builder.mutation({
            query: (input) => ({
                url: `/user/edit-vehicle/${input.id}`,
                method: 'PUT',
                body: { ...input }
            }),
            invalidatesTags: ['UserVehicles']
        }),
        getVehicleById: builder.query({
            query: (id) => `/user/vehicle/${id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['UserVehicles']
        }),
        deleteVehice: builder.mutation({
            query: (id) => ({
                url: `/user/delete-vehicle/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['UserVehicles']
        }),
    })
})

export const {
    useCreateUserVehicleMutation,
    useEditUserVehicleMutation,
    useGetPaginatedUserVehiclesQuery,
    useGetUserVehiclePageChangeMutation,
    useGetVehicleByIdQuery,
    useDeleteVehiceMutation,
    useGetUserVehiclesForRoutesQuery,
} = UserVehicleApiSlice

